import { get } from 'lodash-es';

import { useStoreSelector } from '@hook/store/store.hooks';
import { isString } from '@util/data/is-exist';

export const UserName = () => {
  const profile = useStoreSelector((state) => state.user.data.profile);

  const userName = `${get(profile, 'name')} ${get(profile, 'lastname')}`;

  return isString(userName) ? userName : 'User settings';
};
